import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WebAddresses } from '../app.config';
import { catchError, firstValueFrom, map, Observable, of, tap, throwError } from 'rxjs';
import { ApiResponse } from '../interfaces/api-response';
import { globalUser } from '../helpers/globalFields';
import { MatSnackBar } from '@angular/material/snack-bar';
import { openSnackBar } from '../helpers/genericFunctions';
import { CustomFile } from '../interfaces/custom-file';

@Injectable({
  providedIn: 'root'
})
export class UploadFilesService {

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
  ) { }

  private baseUrl = WebAddresses.tCCTicketServer;

  uploadFile(file: File, ticketID: number, pdescriptionID: number): Observable<HttpEvent<ApiResponse>> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("ticketID", ticketID.toString());
    formData.append("pdescriptionID", pdescriptionID.toString());

    return this.http.post<ApiResponse>(`${this.baseUrl}/api/pfile/create/${ticketID}/${pdescriptionID}`, formData, {
      headers: globalUser.getHeaders(),
      reportProgress: true,
      observe: 'events'
    }).pipe(
      catchError(error => {
        console.error("Error uploading file:", error);
        return throwError(() => new Error("Failed to upload file"));
      })
    );
  }

  findByPDescriptionID(pdescriptionID: number): Observable<CustomFile[]> {
    return this.http.get<ApiResponse>(`${this.baseUrl}/api/pfile/findbydescriptionid/${pdescriptionID}`, {
      headers: globalUser.getHeaders()
    }).pipe(
      map(response => {
        const files = response.data ?? [];
        return files.map((file: any) => ({
          file,
          isUploading: false,
          progress: 0
        })) as CustomFile[];
      }),
      catchError(error => {
        console.error("Error fetching files:", error);
        // If no files found (404) → return empty array
        if (error.status === 404) return of([]);
        return throwError(() => new Error("Failed to fetch files"));
      })
    );
  }

  async downloadFile(fileId: number, filename?: string) {

    try {
      // Use responseType 'blob' to get file data
      const blob = await firstValueFrom(
        this.http.get<Blob>(`${this.baseUrl}/api/pfile/download/${fileId}`, {
          headers: globalUser.getHeaders(),
          responseType: 'blob' as 'json'
        })
      );

      // Determine filename
      const downloadName = filename || `file_${fileId}`;

      // Create a temporary URL for the blob
      const blobUrl = window.URL.createObjectURL(blob);

      // Trigger browser download
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = downloadName;
      a.click();
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error('Failed to download file', err);
      throw err;
    }
  }

  deleteFile(fileId: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/api/pfile/delete/${fileId}`, {
      headers: globalUser.getHeaders()
    });
  }
}





